'use strict';

/**
 * @module nock/intercept
 */
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var _require = require('./intercepted_request_router'),
  InterceptedRequestRouter = _require.InterceptedRequestRouter;
var common = require('./common');
var _require2 = require('util'),
  inherits = _require2.inherits;
var http = require('http');
var debug = require('debug')('nock.intercept');
var globalEmitter = require('./global_emitter');

/**
 * @name NetConnectNotAllowedError
 * @private
 * @desc Error trying to make a connection when disabled external access.
 * @class
 * @example
 * nock.disableNetConnect();
 * http.get('http://zombo.com');
 * // throw NetConnectNotAllowedError
 */
function NetConnectNotAllowedError(host, path) {
  Error.call(this);
  this.name = 'NetConnectNotAllowedError';
  this.code = 'ENETUNREACH';
  this.message = "Nock: Disallowed net connect for \"".concat(host).concat(path, "\"");
  Error.captureStackTrace(this, this.constructor);
}
inherits(NetConnectNotAllowedError, Error);
var allInterceptors = {};
var allowNetConnect;

/**
 * Enabled real request.
 * @public
 * @param {String|RegExp} matcher=RegExp.new('.*') Expression to match
 * @example
 * // Enables all real requests
 * nock.enableNetConnect();
 * @example
 * // Enables real requests for url that matches google
 * nock.enableNetConnect('google');
 * @example
 * // Enables real requests for url that matches google and amazon
 * nock.enableNetConnect(/(google|amazon)/);
 * @example
 * // Enables real requests for url that includes google
 * nock.enableNetConnect(host => host.includes('google'));
 */
function enableNetConnect(matcher) {
  if (typeof matcher === 'string') {
    allowNetConnect = new RegExp(matcher);
  } else if (matcher instanceof RegExp) {
    allowNetConnect = matcher;
  } else if (typeof matcher === 'function') {
    allowNetConnect = {
      test: matcher
    };
  } else {
    allowNetConnect = /.*/;
  }
}
function isEnabledForNetConnect(options) {
  common.normalizeRequestOptions(options);
  var enabled = allowNetConnect && allowNetConnect.test(options.host);
  debug('Net connect', enabled ? '' : 'not', 'enabled for', options.host);
  return enabled;
}

/**
 * Disable all real requests.
 * @public
 * @example
 * nock.disableNetConnect();
 */
function disableNetConnect() {
  allowNetConnect = undefined;
}
function isOn() {
  return !isOff();
}
function isOff() {
  return process.env.NOCK_OFF === 'true';
}
function addInterceptor(key, interceptor, scope, scopeOptions, host) {
  if (!(key in allInterceptors)) {
    allInterceptors[key] = {
      key: key,
      interceptors: []
    };
  }
  interceptor.__nock_scope = scope;

  //  We need scope's key and scope options for scope filtering function (if defined)
  interceptor.__nock_scopeKey = key;
  interceptor.__nock_scopeOptions = scopeOptions;
  //  We need scope's host for setting correct request headers for filtered scopes.
  interceptor.__nock_scopeHost = host;
  interceptor.interceptionCounter = 0;
  if (scopeOptions.allowUnmocked) allInterceptors[key].allowUnmocked = true;
  allInterceptors[key].interceptors.push(interceptor);
}
function remove(interceptor) {
  if (interceptor.__nock_scope.shouldPersist() || --interceptor.counter > 0) {
    return;
  }
  var basePath = interceptor.basePath;
  var interceptors = allInterceptors[basePath] && allInterceptors[basePath].interceptors || [];

  // TODO: There is a clearer way to write that we want to delete the first
  // matching instance. I'm also not sure why we couldn't delete _all_
  // matching instances.
  interceptors.some(function (thisInterceptor, i) {
    return thisInterceptor === interceptor ? interceptors.splice(i, 1) : false;
  });
}
function removeAll() {
  Object.keys(allInterceptors).forEach(function (key) {
    allInterceptors[key].interceptors.forEach(function (interceptor) {
      interceptor.scope.keyedInterceptors = {};
    });
  });
  allInterceptors = {};
}

/**
 * Return all the Interceptors whose Scopes match against the base path of the provided options.
 *
 * @returns {Interceptor[]}
 */
function interceptorsFor(options) {
  common.normalizeRequestOptions(options);
  debug('interceptors for %j', options.host);
  var basePath = "".concat(options.proto, "://").concat(options.host);
  debug('filtering interceptors for basepath', basePath);

  // First try to use filteringScope if any of the interceptors has it defined.
  for (var _i = 0, _Object$values = Object.values(allInterceptors); _i < _Object$values.length; _i++) {
    var _Object$values$_i = _Object$values[_i],
      key = _Object$values$_i.key,
      interceptors = _Object$values$_i.interceptors,
      allowUnmocked = _Object$values$_i.allowUnmocked;
    var _iterator = _createForOfIteratorHelper(interceptors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var interceptor = _step.value;
        var filteringScope = interceptor.__nock_scopeOptions.filteringScope;

        // If scope filtering function is defined and returns a truthy value then
        // we have to treat this as a match.
        if (filteringScope && filteringScope(basePath)) {
          interceptor.scope.logger('found matching scope interceptor');

          // Keep the filtered scope (its key) to signal the rest of the module
          // that this wasn't an exact but filtered match.
          interceptors.forEach(function (ic) {
            ic.__nock_filteredScope = ic.__nock_scopeKey;
          });
          return interceptors;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (common.matchStringOrRegexp(basePath, key)) {
      if (allowUnmocked && interceptors.length === 0) {
        debug('matched base path with allowUnmocked (no matching interceptors)');
        return [{
          options: {
            allowUnmocked: true
          },
          matchOrigin: function matchOrigin() {
            return false;
          }
        }];
      } else {
        debug("matched base path (".concat(interceptors.length, " interceptor").concat(interceptors.length > 1 ? 's' : '', ")"));
        return interceptors;
      }
    }
  }
  return undefined;
}
function removeInterceptor(options) {
  // Lazily import to avoid circular imports.
  var Interceptor = require('./interceptor');
  var baseUrl, key, method, proto;
  if (options instanceof Interceptor) {
    baseUrl = options.basePath;
    key = options._key;
  } else {
    proto = options.proto ? options.proto : 'http';
    common.normalizeRequestOptions(options);
    baseUrl = "".concat(proto, "://").concat(options.host);
    method = options.method && options.method.toUpperCase() || 'GET';
    key = "".concat(method, " ").concat(baseUrl).concat(options.path || '/');
  }
  if (allInterceptors[baseUrl] && allInterceptors[baseUrl].interceptors.length > 0) {
    for (var i = 0; i < allInterceptors[baseUrl].interceptors.length; i++) {
      var interceptor = allInterceptors[baseUrl].interceptors[i];
      if (interceptor._key === key) {
        allInterceptors[baseUrl].interceptors.splice(i, 1);
        interceptor.scope.remove(key, interceptor);
        break;
      }
    }
    return true;
  }
  return false;
}
//  Variable where we keep the ClientRequest we have overridden
//  (which might or might not be node's original http.ClientRequest)
var originalClientRequest;
function ErroringClientRequest(error) {
  http.OutgoingMessage.call(this);
  process.nextTick(function () {
    this.emit('error', error);
  }.bind(this));
}
inherits(ErroringClientRequest, http.ClientRequest);
function overrideClientRequest() {
  // Here's some background discussion about overriding ClientRequest:
  // - https://github.com/nodejitsu/mock-request/issues/4
  // - https://github.com/nock/nock/issues/26
  // It would be good to add a comment that explains this more clearly.
  debug('Overriding ClientRequest');

  // ----- Extending http.ClientRequest

  //  Define the overriding client request that nock uses internally.
  function OverriddenClientRequest() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _common$normalizeClie = common.normalizeClientRequestArgs.apply(common, args),
      options = _common$normalizeClie.options,
      callback = _common$normalizeClie.callback;
    if (Object.keys(options).length === 0) {
      // As weird as it is, it's possible to call `http.request` without
      // options, and it makes a request to localhost or somesuch. We should
      // support it too, for parity. However it doesn't work today, and fixing
      // it seems low priority. Giving an explicit error is nicer than
      // crashing with a weird stack trace. `http[s].request()`, nock's other
      // client-facing entry point, makes a similar check.
      // https://github.com/nock/nock/pull/1386
      // https://github.com/nock/nock/pull/1440
      throw Error('Creating a ClientRequest with empty `options` is not supported in Nock');
    }
    http.OutgoingMessage.call(this);

    //  Filter the interceptors per request options.
    var interceptors = interceptorsFor(options);
    if (isOn() && interceptors) {
      debug('using', interceptors.length, 'interceptors');

      //  Use filtered interceptors to intercept requests.
      // TODO: this shouldn't be a class anymore
      // the overrider explicitly overrides methods and attrs on the request so the `assign` below should be removed.
      var overrider = new InterceptedRequestRouter({
        req: this,
        options: options,
        interceptors: interceptors
      });
      Object.assign(this, overrider);
      if (callback) {
        this.once('response', callback);
      }
    } else {
      debug('falling back to original ClientRequest');

      //  Fallback to original ClientRequest if nock is off or the net connection is enabled.
      if (isOff() || isEnabledForNetConnect(options)) {
        originalClientRequest.apply(this, arguments);
      } else {
        common.setImmediate(function () {
          var error = new NetConnectNotAllowedError(options.host, options.path);
          this.emit('error', error);
        }.bind(this));
      }
    }
  }
  inherits(OverriddenClientRequest, http.ClientRequest);

  //  Override the http module's request but keep the original so that we can use it and later restore it.
  //  NOTE: We only override http.ClientRequest as https module also uses it.
  originalClientRequest = http.ClientRequest;
  http.ClientRequest = OverriddenClientRequest;
  debug('ClientRequest overridden');
}
function restoreOverriddenClientRequest() {
  debug('restoring overridden ClientRequest');

  //  Restore the ClientRequest we have overridden.
  if (!originalClientRequest) {
    debug('- ClientRequest was not overridden');
  } else {
    http.ClientRequest = originalClientRequest;
    originalClientRequest = undefined;
    debug('- ClientRequest restored');
  }
}
function isActive() {
  //  If ClientRequest has been overwritten by Nock then originalClientRequest is not undefined.
  //  This means that Nock has been activated.
  return originalClientRequest !== undefined;
}
function interceptorScopes() {
  var _ref;
  var nestedInterceptors = Object.values(allInterceptors).map(function (i) {
    return i.interceptors;
  });
  return (_ref = []).concat.apply(_ref, _toConsumableArray(nestedInterceptors)).map(function (i) {
    return i.scope;
  });
}
function isDone() {
  return interceptorScopes().every(function (scope) {
    return scope.isDone();
  });
}
function pendingMocks() {
  var _ref2;
  return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(interceptorScopes().map(function (scope) {
    return scope.pendingMocks();
  })));
}
function activeMocks() {
  var _ref3;
  return (_ref3 = []).concat.apply(_ref3, _toConsumableArray(interceptorScopes().map(function (scope) {
    return scope.activeMocks();
  })));
}
function activate() {
  if (originalClientRequest) {
    throw new Error('Nock already active');
  }
  overrideClientRequest();

  // ----- Overriding http.request and https.request:

  common.overrideRequests(function (proto, overriddenRequest, args) {
    //  NOTE: overriddenRequest is already bound to its module.

    var _common$normalizeClie2 = common.normalizeClientRequestArgs.apply(common, _toConsumableArray(args)),
      options = _common$normalizeClie2.options,
      callback = _common$normalizeClie2.callback;
    if (Object.keys(options).length === 0) {
      // As weird as it is, it's possible to call `http.request` without
      // options, and it makes a request to localhost or somesuch. We should
      // support it too, for parity. However it doesn't work today, and fixing
      // it seems low priority. Giving an explicit error is nicer than
      // crashing with a weird stack trace. `new ClientRequest()`, nock's
      // other client-facing entry point, makes a similar check.
      // https://github.com/nock/nock/pull/1386
      // https://github.com/nock/nock/pull/1440
      throw Error('Making a request with empty `options` is not supported in Nock');
    }

    // The option per the docs is `protocol`. Its unclear if this line is meant to override that and is misspelled or if
    // the intend is to explicitly keep track of which module was called using a separate name.
    // Either way, `proto` is used as the source of truth from here on out.
    options.proto = proto;
    var interceptors = interceptorsFor(options);
    if (isOn() && interceptors) {
      var matches = interceptors.some(function (interceptor) {
        return interceptor.matchOrigin(options);
      });
      var allowUnmocked = interceptors.some(function (interceptor) {
        return interceptor.options.allowUnmocked;
      });
      if (!matches && allowUnmocked) {
        var req;
        if (proto === 'https') {
          var ClientRequest = http.ClientRequest;
          http.ClientRequest = originalClientRequest;
          req = overriddenRequest(options, callback);
          http.ClientRequest = ClientRequest;
        } else {
          req = overriddenRequest(options, callback);
        }
        globalEmitter.emit('no match', req);
        return req;
      }

      //  NOTE: Since we already overrode the http.ClientRequest we are in fact constructing
      //    our own OverriddenClientRequest.
      return new http.ClientRequest(options, callback);
    } else {
      globalEmitter.emit('no match', options);
      if (isOff() || isEnabledForNetConnect(options)) {
        return overriddenRequest(options, callback);
      } else {
        var error = new NetConnectNotAllowedError(options.host, options.path);
        return new ErroringClientRequest(error);
      }
    }
  });
}
module.exports = {
  addInterceptor: addInterceptor,
  remove: remove,
  removeAll: removeAll,
  removeInterceptor: removeInterceptor,
  isOn: isOn,
  activate: activate,
  isActive: isActive,
  isDone: isDone,
  pendingMocks: pendingMocks,
  activeMocks: activeMocks,
  enableNetConnect: enableNetConnect,
  disableNetConnect: disableNetConnect,
  restoreOverriddenClientRequest: restoreOverriddenClientRequest,
  abortPendingRequests: common.removeAllTimers
};